import gql from 'graphql-tag';

export const CustomerRestrictionFields = gql`
  fragment CustomerRestrictionFields on CustomerRestriction {
    isApplied
    updatedAt
    updatedBy {
      __typename
      ... on AgentInitiator {
        agent {
          firstName
          lastName
        }
      }
      ... on PlayerInitiator {
        player {
          id
        }
      }
    }
  }
`;
